import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent, LoadingService, NavigationService, ToastService } from '@usucampeao/ui-mobile';
import { finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CadastroService } from '../../../state/cadastros.service';

@Component({
  templateUrl: './confirmar-solicitacao-super-social.page.html',
  styleUrls: ['./confirmar-solicitacao-super-social.page.scss']
})
export class ConfirmarSolicitacaoSuperSocialPage extends BaseComponent implements OnInit {
  private cadastroId: string;
  public superSocialAceito = false;

  constructor(
    private readonly cadastrosService: CadastroService,
    private readonly loadingService: LoadingService,
    private readonly navigationService: NavigationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly toastService: ToastService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        tap(params => this.cadastroId = params.cadastroId),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe()
  }

  public async solicitarSuperSocial(): Promise<void> {
    if (!this.superSocialAceito) {
      return;
    }

    await this.loadingService.createLoader();
    this.cadastrosService.solicitarSuperSocial(this.cadastroId)
      .pipe(
        switchMap(() => this.toastService.success('Super social solicitado com sucesso.')),
        finalize(() => this.loadingService.dismiss()),
      )
      .subscribe({
        next: () => {
          this.router.navigate(['../moradores-com-renda'], { relativeTo: this.route, replaceUrl: true });
        },
        error: () => {
          this.toastService.error('Erro ao solicitar super social. Tente novamente mais tarde.');
        }
      })
  }

  public voltar(): void {
    this.navigationService.voltar();
  }
}
